import { t, font } from "@realtyflows/ui";

export default function ScoreBadge({ score }) {
  const color = score >= 80 ? t.emerald : score >= 50 ? t.amber : t.coral;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <div style={{ width: 48, height: 6, background: t.border, borderRadius: 99, overflow: "hidden" }}>
        <div style={{ width: `${score}%`, height: "100%", background: color, borderRadius: 99, transition: "width 0.6s ease" }} />
      </div>
      <span style={{ fontSize: 12, fontWeight: 700, color, fontFamily: font.mono }}>{score}%</span>
    </div>
  );
}
